import { request } from "../helper/axios_helper";

// Project API. A project scopes Dashboard, Library, Tasks, Master Suite,
// Automation, Results and Jobs. Environments, Settings, Agents and Users
// are global and unaffected.
//
// The active project travels on every request as an X-Project-Id header,
// attached once in helper/axios_helper.js — services never pass it.

export const getProjects = () => request("GET", "/api/auth/project/list");

export const createProject = (data) =>
  request("POST", "/api/auth/project/create", data);

export const updateProject = (id, data) =>
  request("PUT", `/api/auth/project/update/${id}`, data);

export const deleteProject = (id) =>
  request("DELETE", `/api/auth/project/delete/${id}`);

// The project this user lands in at login.
export const getDefaultProject = () =>
  request("GET", "/api/auth/project/default");

export const setDefaultProject = (id) =>
  request("POST", `/api/auth/project/default/${id}`);

export const getProjectIsAdmin = () =>
  request("GET", "/api/auth/project/is-admin");
